import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { SigninRequest, SigninResponse } from '~/features/auth/types/auth.type';

/**
 * 관리자 로그인
 * @description 관리자 계정으로 로그인하여 JWT 토큰을 발급받습니다.
 * @endpoint POST /admin/auth/signin
 * @param body - 로그인 요청 데이터 (userId, password)
 * @returns 로그인 응답 (accessToken, expired)
 */
export function postSigninApi(body: SigninRequest) {
  return axiosInstance.post<ApiResponse<SigninResponse>>('/admin/auth/signin', body);
}
